import type { Draft } from '@reduxjs/toolkit';
import type { QuoteData, QuoteStep } from '../types/quote.types';
import { initialState } from './quoteInitialState';

// The data each step owns. `summary` owns none. Record<> typing is load-bearing:
// a new QuoteStep fails the build rather than silently falling through (P-D3).
const CLEAR_STEP_DATA: Record<QuoteStep, (s: Draft<QuoteData>) => void> = {
    dealer: (s) => {
        s.selectedDealer = null;
    },
    vehicle: (s) => {
        s.selectedVehicle = null;
    },
    product: (s) => {
        s.selectedProduct = null;
        s.dismissedAutoAddOnIds = [];
        s.autoAddOnBaselinePending = false;
    },
    configuration: (s) => {
        s.configuredServices = [];
        s.configuredAddOns = [];
        s.anchorDate = null;
        s.dismissedAutoAddOnIds = [];
        s.autoAddOnBaselinePending = false;
        s.resolvedPlanId = null;
        s.servicePlanSessionId = null;
        s.smriqConfirmedVehicle = null;
        s.smriqPlanSettings = null;
        s.scheduleOverrides = undefined;
    },
    customer: (s) => {
        s.selectedCustomer = null;
    },
    payment: (s) => {
        s.paymentOptions = initialState.paymentOptions;
        s.paymentSelection = undefined;
    },
    summary: () => {},
};

export const clearSteps = (state: Draft<QuoteData>, steps: readonly QuoteStep[]) => {
    for (const step of steps) {
        state.completedSteps = state.completedSteps.filter((c) => c !== step);
        state.errors[step] = [];
        CLEAR_STEP_DATA[step](state);
    }
};
